<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="item.childs">
      <router-link v-if="hasOneShowingChildren(item.childs) && item.childs[0].childs!=null&&!item.alwaysShow" :to="item.path+'/'+item.childs[0].path"
        :key="item.childs[0].title">
        <el-menu-item :index="item.path+'/'+item.childs[0].path" :class="{'submenu-title-noDropdown':!isNest}">
          <svg-icon v-if="item.children[0].meta&&item.childs[0].meta.icon" :icon-class="item.childs[0].meta.icon"></svg-icon>
          <span v-if="item.childs[0].meta&&item.childs[0].meta.title" slot="title">{{item.childs[0].meta.title}}</span>
        </el-menu-item>
      </router-link>
      <el-submenu v-else :index="item.title||item.path" :key="item.name">
        <template slot="title">
          <svg-icon v-if="item.icon" :icon-class="item.icon"></svg-icon>
          <span v-if="item.title&&item.title" slot="title">{{item.title}}</span>
        </template>

        <template v-for="child in item.childs">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.childs&&child.childs.length>0" :routes="[childs]" :key="child.path"></sidebar-item>

        <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
            <el-menu-item :index="item.path+'/'+child.path">
              <svg-icon v-if="child.icon" :icon-class="child.icon"></svg-icon>
              <span v-if="child.title" slot="title">{{child.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>

    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasOneShowingChildren(children) {
      return true;
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue